import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getAboutCaroselSliceContent = createAsyncThunk('/aboutCarosels/content', async () => {
	const response = await axios.post(`${API_URL}/getAboutCarouselItem`);
    console.log(response.data);
	return response;
})

export const aboutCaroselSlice = createSlice({
    name: 'aboutCarosels',
    initialState: {
        isLoading: false,
        aboutCarosels : []
    },
    reducers: {
    },
    extraReducers: {
		[getAboutCaroselSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getAboutCaroselSliceContent.fulfilled]: (state, action) => {
			state.aboutCarosels = action.payload.data
			state.isLoading = false
		},
		[getAboutCaroselSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default aboutCaroselSlice.reducer